document.querySelectorAll('.single-review__brand-desc').forEach(block => {
    const btn = block.querySelector('.toggle-text');
    const content = block.querySelector('.text-content');

    btn.addEventListener('click', () => {
        if (block.classList.contains('expanded')) {
            content.style.maxHeight = '3em';
            btn.textContent = 'Show more';
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            btn.textContent = 'Show less';
        }
        block.classList.toggle('expanded');
    });
});
